<!--新闻管理-->
<template>
  <div class="newsGlIndexClass">
    <div>
      <nav-com activeIndex="8"></nav-com>
    </div>

    <div style="padding: 15px">
      <!-- 搜索栏 开始 -->
      <div style="text-align: left">
        <div class="searchMainClass">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form>
                <el-form-item label="标题： ">
                  <el-input
                    clearable
                    placeholder="请输入标题..."
                    v-model="search.TITLE"
                    style="width: 200px"
                  ></el-input>

                  <el-button
                    type="success"
                    style="margin-left: 15px; margin-right: 15px"
                    @click="mainLoad"
                    icon="el-icon-search"
                  >
                    查询
                  </el-button>
                  <el-button
                    type="primary"
                    style="margin-right: 15px"
                    @click="openAddModal"
                    icon="el-icon-plus"
                  >
                    新增
                  </el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 搜索栏 结束 -->

      <!-- table列表 开始 -->
      <div style="position: relative">
        <el-table
          ref="tableRef"
          height="80vh"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" label="序号" width="60">
          </el-table-column>
          <template v-for="(col, index) in tableColumns">
            <el-table-column
              :prop="col.colName"
              :label="col.colText"
              :key="index"
              :width="col.colWidth"
              v-if="col.colShow"
            >
              <template slot-scope="scope">
                <!-- 创建时间格式化 -->
                <div v-if="col.colName === 'CREATETIME'">
                  {{ formatDateTime(scope.row.CREATETIME) }}
                </div>
                <!-- 内容预览 -->
                <div v-else-if="col.colName === 'CONTENT'">
                  <el-tooltip placement="top" :content="scope.row.CONTENT">
                    <span>{{ truncateText(scope.row.CONTENT, 30) }}</span>
                  </el-tooltip>
                </div>
                <!-- 普通字段 -->
                <div v-else>{{ scope.row[col.colName] }}</div>
              </template>
            </el-table-column>
          </template>
          
          <!-- 操作列 -->
          <el-table-column label="操作" width="320" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="success"
                size="small"
                @click="handleViewDetail(scope.row)"
                icon="el-icon-view"
              >
                查看详情
              </el-button>
              <el-button
                type="primary"
                size="small"
                @click="handleViewEdit(scope.row)"
                icon="el-icon-edit"
              >
                修改
              </el-button>
              <el-button
                type="danger"
                size="small"
                @click="handleDelete(scope.row)"
                icon="el-icon-delete"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right; margin-top: 20px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageSet.currentPage"
            :page-sizes="pageSet.pageSizeS"
            :page-size="pageSet.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageSet.totalNums"
          >
          </el-pagination>
        </div>
      </div>
      <!-- table列表 结束 -->

      <!-- 添加/编辑对话框 开始 -->
      <el-dialog
        :title="czDataModel.TYPE === 'ADD' ? '新增内容' : '编辑内容'"
        :visible.sync="czDataModel.dialogVisible"
        width="90%"
        :close-on-click-modal="false"
        fullscreen
      >
        <el-form
          :model="czDataModel.data"
          ref="newsForm"
          label-width="120px"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="标题" required label-width="120px">
                <el-input
                  v-model="czDataModel.data.TITLE"
                  placeholder="请输入标题"
                  maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="图片" label-width="120px">
                <div style="text-align: left;">
                  <el-upload
                    class="upload-image-left"
                    :action="uploadImgUrl"
                    list-type="picture-card"
                    :file-list="imageFileList"
                    :on-success="handleImageSuccess"
                    :before-upload="beforeImageUpload"
                    :on-remove="handleImageRemove"
                    :limit="1"
                    :on-exceed="handleImageExceed"
                  >
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">
                      只能上传1张jpg/png文件，且不超过5MB
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="内容" required label-width="120px">
                <div style="text-align: left;">
                  <editor-com
                    :value="czDataModel.data.CONTENT"
                    editorType="SSGC"
                    :setEditorFn="setEditorFn"
                  >
                  </editor-com>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="czDataModel.dialogVisible = false">
            取 消
          </el-button>
          <el-button type="primary" @click="saveNewsHandler" icon="el-icon-check">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <!-- 添加/编辑对话框 结束 -->
    </div>
  </div>
</template>

<script>
import EditorCom from "../../components/editorCom/EditorCom.vue";
import NavCom from "../../components/navCom/NavMainCom.vue";
import allParam from "../../allParam/allParam.vue";
export default {
  name: "NewsGlIndex",
  components: { NavCom,EditorCom },
  data() { 
    return {
      uploadImgUrl: allParam.uploadImgUrl,
      tableHeight: 0,
      op: "adminNewsGl",
      tableColumns: [
         {
          colName: "ID",
          colText: "标题ID",
          colShow: true,
          colWidth: ""
        },
        {
          colName: "TITLE",
          colText: "标题",
          colShow: true,
          colWidth: ""
        },
        {
          colName: "CONTENT",
          colText: "内容预览",
          colShow: false,
          colWidth: "200"
        },
        {
          colName: "CREATETIME",
          colText: "创建时间",
          colShow: true,
          colWidth: "150"
        }
      ],
      tableData: [],
      imageFileList: [],
      czDataModel: {
        dialogVisible: false,
        data: {},
        TYPE: "",
        rows: {}
      },
      // 分页设置
      pageSet: {
        currentPage: 1,
        pageSizeS: [10, 20, 50, 100],
        pageSize: 10,
        totalNums: 0
      },
      search: {
        TITLE: ""
      },
      newsTypeList: []
    };
  },
  created() {
    this.utilPost = this.$util.handler;
  },
  mounted() {
    this.loadNewsTypes();
    this.mainLoad();
  },
  methods: {
    setEditorFn(editorResultHtml, editorType) {
      //alert(editorResultHtml)
      this.czDataModel.data.CONTENT=editorResultHtml
    },
    // 文本截断
    truncateText(text, maxLength) {
      if (!text) return "-";
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + "...";
    },
    // 格式化日期时间 yyyyMMddHHmmss -> yyyy-MM-dd HH:mm:ss
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return "-";
      let str = dateTimeStr.toString().trim();
      
      // 如果已经是格式化好的，直接返回
      if (str.includes("-") && str.includes(":")) {
        return str;
      }
      
      // 处理 yyyyMMddHHmmss 格式（14位）
      if (/^\d{14}$/.test(str)) {
        const year = str.substring(0, 4);
        const month = str.substring(4, 6);
        const day = str.substring(6, 8);
        const hour = str.substring(8, 10);
        const minute = str.substring(10, 12);
        const second = str.substring(12, 14);
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      }
      
      // 处理 yyyyMMdd 格式（8位）
      if (/^\d{8}$/.test(str)) {
        const year = str.substring(0, 4);
        const month = str.substring(4, 6);
        const day = str.substring(6, 8);
        return `${year}-${month}-${day} 00:00:00`;
      }
      
      // 其他格式直接返回
      return str;
    },
    // 选择变化
    handleSelectionChange(val) {
      this.czDataModel.rows = val;
    },
    // 查看/修改
    handleViewEdit(row) {
      this.czDataModel.rows = [row];
      this.openEditorModal();
    },
    // 删除单条记录
    handleDelete(row) {
      this.czDataModel.rows = [row];
      this.deleteModal();
    },
    // 查看详情
    handleViewDetail(row) {
      // 跳转到详情页面，通过路由传递ID
      this.$router.push({ 
        path: '/newsDetail', 
        query: { id: row.ID }
      });
    },
    // 分页大小变化
    handleSizeChange(val) {
      this.pageSet.pageSize = val;
      this.mainLoad();
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.pageSet.currentPage = val;
      this.mainLoad();
    },
    // 加载主列表数据
    mainLoad() {
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "mainLoad"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        this.$refs.tableRef.doLayout();
        if (!data.isSuccess) {
          this.$message.error(data.msg);
          return;
        }
        this.pageSet.totalNums = data.totalNums;
        this.tableData = data.content;
      });
    },
    // 打开新增对话框
    openAddModal() {
      this.czDataModel.data = {
        TITLE: "",
        CONTENT: "",
        IMGPATH: "",
        IMGPATH_YS: "",
        URL: ""
      };
      this.imageFileList = [];
      this.czDataModel.dialogVisible = true;
      this.czDataModel.TYPE = "ADD";
    },
    // 打开编辑对话框
    openEditorModal() {
      if (this.czDataModel.rows.length !== 1) {
        this.$message.warning("请选择一条数据进行编辑");
        return;
      }
      this.czDataModel.dialogVisible = true;
      this.czDataModel.TYPE = "UPT";
      var rowData = JSON.parse(JSON.stringify(this.czDataModel.rows[0]));
      this.czDataModel.data.CONTENT = rowData.CONTENT;
      this.czDataModel.data = rowData;
      
      // 初始化图片字段
      if (!this.czDataModel.data.IMGPATH) {
        this.czDataModel.data.IMGPATH = "";
      }
      if (!this.czDataModel.data.IMGPATH_YS) {
        this.czDataModel.data.IMGPATH_YS = "";
      }
      if (!this.czDataModel.data.URL) {
        this.czDataModel.data.URL = "";
      }
      
      // 如果有图片，显示在上传组件中
      this.imageFileList = [];
      if (this.czDataModel.data.URL) {
        this.imageFileList = [{
          name: "image",
          url: this.czDataModel.data.URL
        }];
      }
    },
    // 删除
    deleteModal() {
      if (this.czDataModel.rows.length === 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确定要删除选中的内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.czDataModel.TYPE = "DEL";
          this.saveNewsHandler();
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 保存新闻
    saveNewsHandler() {
      var data = this.czDataModel.data;
      
      // 验证必填项
      if (this.czDataModel.TYPE !== "DEL") {
        if (!data.TITLE || data.TITLE.trim() === "") {
          this.$message.warning("标题不能为空");
          return;
        }
        if (!data.CONTENT || data.CONTENT.trim() === "") {
          this.$message.warning("内容不能为空");
          return;
        }
      }

      this.$confirm("确定要提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var CONTENTLIST = [];
          if (this.czDataModel.TYPE === "DEL") {
            CONTENTLIST = this.czDataModel.rows;
          } else {
            // 调试：打印提交的数据
            console.log("===== 前端提交的新闻数据 =====");
            console.log("操作类型:", this.czDataModel.TYPE);
            console.log("完整数据:", data);
            console.log("图片字段:");
            console.log("  IMGPATH:", data.IMGPATH);
            console.log("  IMGPATH_YS:", data.IMGPATH_YS);
            console.log("  URL:", data.URL);
            console.log("==============================");
            CONTENTLIST.push(data);
          }

          var busData = {
            TYPE: this.czDataModel.TYPE,
            CONTENTLIST: CONTENTLIST
          };
          var paramData = {
            headerData: {
              op: this.op,
              methodName: "insertOrUptOrDel"
            },
            busData: busData
          };
          this.utilPost.paramData = paramData;
          this.utilPost.sendPost().then(data => {
            if (!data.isSuccess) {
              this.$message.error(data.msg);
              return;
            }
            this.$message.success(data.msg);
            this.czDataModel.data = {};
            this.czDataModel.rows = [];
            this.mainLoad();
            this.czDataModel.dialogVisible = false;
          });
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },
    // 加载新闻类型列表
    loadNewsTypes() {
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "getNewsTypes"
        },
        busData: {}
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.isSuccess) {
          this.newsTypeList = data.content.TYPELIST;
        } else {
          this.$message.error("获取新闻类型失败：" + data.msg);
        }
      });
    },
    // 图片上传成功回调
    handleImageSuccess(response, file, fileList) {
      console.log("图片上传返回数据：", response);
      if (response.isSuccess) {
        this.czDataModel.data.IMGPATH = response.content.filePath || "";
        this.czDataModel.data.IMGPATH_YS = response.content.filePath_ys || response.content.filePath || "";
        this.czDataModel.data.URL = response.content.url || "";
        console.log("保存的图片字段：", {
          IMGPATH: this.czDataModel.data.IMGPATH,
          IMGPATH_YS: this.czDataModel.data.IMGPATH_YS,
          URL: this.czDataModel.data.URL
        });
        this.$message.success("图片上传成功！");
      } else {
        this.$message.error(response.msg || "图片上传失败！");
        const index = fileList.indexOf(file);
        if (index > -1) {
          fileList.splice(index, 1);
        }
      }
    },
    // 图片上传前验证
    beforeImageUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isImage) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isImage && isLt5M;
    },
    // 图片移除回调
    handleImageRemove(file, fileList) {
      this.czDataModel.data.IMGPATH = "";
      this.czDataModel.data.IMGPATH_YS = "";
      this.czDataModel.data.URL = "";
      this.$message.success("图片已移除");
    },
    // 图片超出数量限制提示
    handleImageExceed(files, fileList) {
      this.$message.warning("只能上传1张图片，请先删除已上传的图片再上传新图片");
    }
  }
};
</script>

<style lang="scss" scoped>
.newsGlIndexClass {
  .searchMainClass .el-input {
    width: 200px !important;
  }
  .el-table td.el-table__cell div {
    font-weight: 600 !important;
  }
  .cell {
    text-align: center !important;
  }
  /deep/ .el-dialog {
    margin-top: 0 !important;
  }
  /deep/ .el-dialog__body {
    padding: 20px;
    max-height: calc(100vh - 120px);
    overflow-y: auto;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  /deep/ .el-form-item__label {
    line-height: 32px !important;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 15px;
  }
  
  /* 单选框靠左对齐 */
  /deep/ .el-radio-group {
    text-align: left;
  }
  
  /deep/ .el-radio {
    margin-right: 30px;
  }
  
  /* 富文本编辑器样式 */
  /deep/ .editor-com {
    text-align: left;
  }
  
  /deep/ .w-e-text-container {
    text-align: left !important;
  }
  
  /deep/ .w-e-text {
    text-align: left !important;
  }
  
  /deep/ .w-e-text p {
    text-align: left !important;
  }
  
  /* 图片上传组件靠左对齐 */
  .upload-image-left {
    text-align: left;
    display: inline-block;
  }
  
  /deep/ .upload-image-left .el-upload-list {
    text-align: left;
  }
  
  /deep/ .upload-image-left .el-upload--picture-card {
    float: none;
  }
  
  /deep/ .upload-image-left .el-upload-list--picture-card .el-upload-list__item {
    float: none;
    display: inline-block;
  }
  
  /* 上传组件样式 */
  .upload-demo {
    display: inline-block;
    text-align: left;
  }
  
  /deep/ .el-upload-list--picture-card {
    text-align: left;
  }
  
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
  }
  
  /deep/ .el-upload--picture-card {
    width: 148px;
    height: 148px;
    line-height: 148px;
    float: left;
  }
  
  /deep/ .el-upload__tip {
    font-size: 12px;
    color: #606266;
    line-height: 1.5;
    text-align: left;
    clear: both;
  }
  
  // 单行文本溢出省略
  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
    span {
      display: inline-block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/view/newsGlIndex/NewsGlIndex.vue